// Place your custom JavaScript here.
	//makes button active onclick

	// function buttonActiveState(elmnt) {
	// 	var allBtn = elmnt.closest("div");
	// 	allBtn = allBtn.getElementsByClassName("button");
	// 	var i = allBtn.length;
	// 	while(i--){
	// 		allBtn[i].classList.remove("active");
	// 	}
	// 	elmnt.classList.toggle("active");
	// }

	$(document).ready(function () {
		$('ui-state-default').removeAttr("href");
	
		//add smoothy scroll
		function getQueryVariable(variable){
			var query = window.location.search.substring(1);
			var vars = query.split("&");
			for (var i=0;i<vars.length;i++) {
					var pair = vars[i].split("=");
					if(pair[0] == variable){return pair[1];}
			}
			return(false);
	 }
	
	 window.goToAnchorLink = function(x){
		 if(anchor != ''){
			 var loc = $('#'+x);
			 var stickyHeight = $("#top").height();
	
			 Foundation.SmoothScroll.scrollToLoc(loc, {
				 threshold: 0,
				 offset: stickyHeight
			 });
		 }
	 }
	
	 if (getQueryVariable("anchor") != '') {
		 var anchor = getQueryVariable("anchor");
		 setTimeout(function(){ goToAnchorLink(anchor); }, 1000);
	 }
	
	
		
		// Initialize Swiper Carousel.
		if ($('.logo-slider').length) {
			const logoSlider = new Swiper('.logo-slider', $('.logo-slider').data().swiperOptions);
		}
		if ($('.quote-slider').length) {
			const quoteSlider = new Swiper('.quote-slider', $('.quote-slider').data().swiperOptions);
		}
	
		$('.swiper-container .swiper-slide').on('click', function() {
			const slideId = $(this).attr('id');
			const container = $(this)
				.parent()
				.parent()
				.attr('class')
				.match(/\S*slider\b/i)[0];
			// openFullscreenSwiper(slideId, container);
		});
	
		function openFullscreenSwiper(initialSlideNumber, container) {
			const mainSwiperMarkup = $(`.${container}.swiper-container`).html();
	
			$('#fullscreen-swiper')
				.append(mainSwiperMarkup + "<div id='fullscreen-swiper-close'>X</div>")
				.fadeIn();
	
			const fullscreenSwiper = new Swiper('#fullscreen-swiper', {
				pagination: {
					el: '.swiper-pagination',
					clickable: true,
				},
				navigation: {
					nextEl: '.swiper-button-next',
					prevEl: '.swiper-button-prev',
				},
				slidesPerView: 1,
				centeredSlides: true,
				spaceBetween: 20,
				loop: true,
				initialSlide: initialSlideNumber,
			});
	
			$('#fullscreen-swiper-backdrop').fadeIn();
			$('body, html').addClass('no-scroll');
	
			$('#fullscreen-swiper-close').on('click', () => {
				$('#fullscreen-swiper')
					.hide()
					.empty();
				$('#fullscreen-swiper-backdrop').fadeOut();
				$('body, html').removeClass('no-scroll');
			});
		}
	
	
		var clicked1 = false;
		$(".top-search .search-form .input-group .input-group-field").width(0);
		$(".top-search .search-form .input-group .input-group-field").hide();
		
		$(".top-search .search-form .input-group .input-group-label").on('click', function () {
			if (clicked1) {
				clicked1 = false;
				$(".top-search .search-form .input-group .input-group-field").width(0);
				$(".top-search .search-form .input-group .input-group-field").hide();
				
	
			} else {
				clicked1 = true;	
				$(".top-search .search-form .input-group .input-group-field").width(200).height(6);		
				$(".top-search .search-form .input-group .input-group-field").show();
				
			}
		});
		
			$('#PriceTable').append('<img src="' + priceListImage + '">');
	
	
		$(".gform_body ul li.inzamelpunt").change(function () {
			var post_ID = $(this).find('option:selected').val();
			var locationsArr = [locations];
			var firstArr = locationsArr[0];
			
			var locInfo = (jQuery.inArray(post_ID, firstArr) === -1);
			if (locInfo == true) {
				var selectLoc = firstArr[post_ID];
				var dataString = '<div class="ginput_container">';
				dataString += '<ul class="open-hours">';
				dataString += '<li><span class="h4">Openingstijden</span></li>';
	
				$.each(selectLoc, function (item, value) {
					dataString += '<li>';
					dataString += ('<span>' + selectLoc[item]['day'] + '</span>' + selectLoc[item]['time']);
					dataString += '</li>';
				});
	
				dataString += '</ul>';
				dataString += '</div>';
				console.log(dataString);
				$('.opening-hours').html(dataString);			
			}
	
		});
		
		
		//Company info address and 
		$(".gform_body ul li.inzamelpunt").change(function () {
			var post_ID = $(this).find('option:selected').val();
			var addressesArr = [addresses];
			console.log(addressesArr, 'Hier log ik addresses array');
			var infoArr = addressesArr[0];
	
			var compInfo = (jQuery.inArray(post_ID, infoArr) === -1);
			if (compInfo == true) {
				var selectAddress = infoArr[post_ID];
				var company_address = '<div class="ginput_container">';
				company_address += '<ul class="open-hours">';
				company_address += '<li><span class="h4">Adresgegevens</span></li>';
				console.log(selectAddress['street_number'])
				// $.each(selectAddress, function (value) {
					company_address += '<li>';
					company_address += ('<span>' + selectAddress['street_number'] + '</span>');
					company_address += '</li>';
					company_address += '<li>';
					company_address += ('<span>' + selectAddress['zipcode_place'] + '</span>');
					company_address += '</li>';
				// });
	
				company_address += '</ul>';
				company_address += '</div>';
				
				$('.company_info').html(company_address);			
			}
	
		});
		
		//moving div class to container
		$('.gform_footer ').appendTo('.algemeen');
	
		$(".algemeen").hide();
		if($(".informatieID").hasClass("active")){
			$(".inzamelpunt").hide();
			$(".meldmijaanniet").hide();
			
		}
		$(".informatieID").click(function(){
			$(".inzamelpunt").hide();
			$(this).addClass('active');
			$(".algemeen").show();
			$(".meldmijaan").show();
			$(".gform_button").val('Versturen');
			$(".kies-een-datumn").hide();
			console.log($(".gform_button").val())
			$(".meldmijaanniet").hide()
			$(".custumer-adress").show();
			$(".inzamelpunt").hide();
			$(".open-hours").hide();
		});
		$(".pakketID").click(function(){
			$(".meldmijaan").show();
			$(".meldmijaanniet").hide()
			$(".meldmijaanniet").hide()
			$(".kies-een-datumn").hide();
			$(".algemeen").show();
			$(".custumer-adress").hide();
			$(".inzamelpunt").hide();
			$(".algemeen").show();
			$(".gform_button").val('Versturen');
			$(".open-hours").hide();
		});
		$(".inzamelID ").click(function(){
			$(".custumer-adress").hide();
			$(".meldmijaan").hide();
			$(".kies-een-datumn").show();
			$(".meldmijaanniet").show()
			$(".gform_button").val('Meld mij aan');
			console.log($(".gform_button").val())
			$(".inzamelpunt").show();
			$(".algemeen").show();
		});
		// $(".dr-afmetingen").click(function () {
		// 	$(".gfield_select")[0].reset();
		// });
		
	
		$("#PriceTable").hide();
		$("#slide-content").click(function () {
			
			$("#PriceTable").slideDown("slow");
		});
		
		// //price table script	
		var clicked = false;
		$("#PriceTable").hide();
		$("#slide-content").on('click', function () {
			if (clicked) {
				clicked = false;
				$("#PriceTable").slideUp("slow");
	
			} else {
				clicked = true;			
				$("#PriceTable").slideDown("slow");
			}
		});
	
		// Remove empty P tags created by WP inside of Accordion and Orbit
		$('.accordion p:empty, .orbit p:empty').remove();
	
		// Adds Flex Video to YouTube and Vimeo Embeds
		$('iframe[src*="youtube.com"], iframe[src*="vimeo.com"]').each(function () {
			if ($(this).innerWidth() / $(this).innerHeight() > 1.5) {
				$(this).wrap("<div class='widescreen responsive-embed'/>");
			} else {
				$(this).wrap("<div class='responsive-embed'/>");
			}
		});
	
		if (!$('.top-bar-overlay li').hasClass('hide animated')) {
			$('.top-bar-overlay li').each(function() {
				let item = $(this);
				item.addClass('hide animated');
			});
		}
	
		$('.top-bar-overlay .dropdown > li').each(function(index) {
			let item = $(this);
			item.addClass(`delay-${index}`);
		});
		$('.top-bar-overlay .submenu').each(function() {
			$(this).children().each(function(index) {
				$(this).addClass(`delay-${index}`);
			});
		});
	
		$("[data-toggle='top-bar-overlay']").click(() => {
			if ($('.top-bar-overlay').hasClass('visible')) {
				$('body').removeClass('overlay-visible');
				$('.top-bar-overlay').removeClass('visible');
				$('.overlay-logo').removeClass('fadeInUp');
				$('.trail').removeClass('zoomIn');
				$('.overlay-portfolio').removeClass('fadeInUp');
				$('.top-bar-overlay li').each(function () {
					let item = $(this);
					item.addClass('hide');
					item.removeClass('fadeInUp visible');
				});
			} else {
				$('body').addClass('overlay-visible');
				$('.top-bar-overlay').addClass('visible');
				$('.overlay-logo').addClass('fadeInUp');
				$('.trail').addClass('zoomIn');
				$('.overlay-portfolio').addClass('fadeInUp');
				$('.top-bar-overlay li').each(function () {
					let item = $(this);
					item.removeClass('hide');
					item.addClass('fadeInUp visible');
				});
			}
			$('body').toggleClass('no-scroll');
		});
	
	
	
		$("[data-toggle='top-bar-overlay']").click(() => {
			$('body').toggleClass('no-scroll');
		});
	
	
		//code testing
	
	
		$("#inzamelpunten-select").selectedIndex = -1;
	
		$("#inzamelpunten-select").on('change', function () {
			let goto = this.value;
			window.location = goto;
		});
	
		$("#inzamelpunten-select optgroup").each(function () {
			if ($(this).children().length < 1) {
				$(this).remove();
			}
		});
	
	
		const populateInzamelpunten = () => {
			const $select = $('.inzamelpunt select');
			const $options = $('.inzamelpunt select option');
			$options.not(':first').each(function () {
				const label = $(this).text();
				if (label.indexOf('--') !== 0) {
					$('<optGroup/>')
						.attr('label', label)
						.appendTo($select);
					$(this).remove();
				} else {
					$select.find('optGroup').last().append($(this));
					const cleaned = $(this).html().replace('--', '');
					$(this).html(cleaned);
				}
			});
	
			const $optgroup = $('.inzamelpunt select optgroup');
			$optgroup.each(function () {
				if ($(this).children().length < 1) {
					$(this).remove();
				}
			});
		};
	
		populateInzamelpunten();
	
		$('.location').on('click', () => {
			getPosition()
				.then(success)
				.catch(fail);
		});
	
		const getPosition = options => {
			return new Promise((resolve, reject) => {
				navigator.geolocation.getCurrentPosition(resolve, reject, options);
				$('.location').html('<i class="fas fa-sync fa-spin fa-fw" aria-hidden="true"></i> Locatie zoeken...');
			});
		};
	
		function success(position) {
			var latitude = position.coords.latitude;
			var longitude = position.coords.longitude;
			return new Promise((resolve, reject) => {
				$.ajax({
					type: 'POST',
					url: '/zonklaar2018/getLocation.php',
					data: `latitude=${latitude}&longitude=${longitude}`,
					success(msg) {
						if (msg) {
							$("#location").html(msg);
							$('.location').addClass('success').html('<i class="fas fa-check fa-fw" aria-hidden="true"></i> Locatie gevonden!');
						} else {
							$('.location').addClass('alert').html('<i class="fas fa-times fa-fw" aria-hidden="true"></i> Geen locatie gevonden!');
						}
					}
				});
			});
		}
	
		function fail(error) {
			return new Promise((resolve, reject) => {
				$.ajax({
					type: 'POST',
					url: '/zonklaar2018/getHQ.php',
					success(msg) {
						if (msg) {
							$("#location").html(msg);
							$('.location').addClass('success').html('<i class="fas fa-check fa-fw" aria-hidden="true"></i> Locatie gevonden!');
						} else {
							$('.location').addClass('alert').html('<i class="fas fa-times fa-fw" aria-hidden="true"></i> Geen locatie gevonden!');
						}
					}
				});
			});
		}
	
		// General variables for forms.
		let inputNumber;
		const drStepPrijsindicatie = $('.js-step-prijsindicatie');
		let drStepPrijsindicatieSpan = drStepPrijsindicatie.find('span');
		const drStepInstructies = $('.js-step-instructies');
		const drStepExtra = $('.js-step-extra');
		const drStepExtraInfo = $('.js-step-extra .info');
		const drStepExtraInzamelpunten = $('.js-step-extra .inzamelpunten');
		const drStepFooter = $('.form-direct-regelen .gform_footer');
		
	
		/**
		 * BOOTTENT
		 */
		const bootFormStep0 = $('.form-direct-regelen.boottent .js-step-0');
		const bootFormStep0Input = bootFormStep0.find('input[type="radio"]');
		const bootFormStep1Wel = $('.form-direct-regelen.boottent .js-step-1-wel');
		const bootFormStep1Niet = $('.form-direct-regelen.boottent .js-step-1-niet');
		const bootFormStep2Niet = $('.form-direct-regelen.boottent .js-step-2-niet');
		const bootFormStep3Niet = $('.form-direct-regelen.boottent .js-step-3-niet');
		const gewicht = $('.form-direct-regelen.boottent .dr-gewicht input');
		const typeBoot = $('.form-direct-regelen.boottent .dr-type-boot select');
		const bootFormStep2WelInput = $('.form-direct-regelen.boottent .dr-gewicht-kg input');
		const typeBoottent = $('.form-direct-regelen.boottent .dr-type-boottent select');
		const bootFormStep3NietRadio = $('.form-direct-regelen.boottent .dr-bootlengte input');
		let bootFormPrice = $('.form-direct-regelen.boottent .gform_hidden input');
		let selectedGewicht = '';
		let selectedBootType = '';
		let selectedBootlengte = '';
	
	
		// Initially hide step fields.
		bootFormStep1Wel.addClass('hide');
		bootFormStep1Niet.addClass('hide');
		bootFormStep2Niet.addClass('hide');
		bootFormStep3Niet.addClass('hide');
		$(".instruction ").hide();
	
		// Set boottent price based on selection
		let baseKgBoottent = 0;
	
		function getKgBoottent(boot) {
			
			switch (boot) {
			
				case 'kajuitzeiljacht':
					baseKgBoottent = 20;
					break;
				case 'kajuitmotorjacht':
					baseKgBoottent = 20;
					break;
				case 'open-motorboot':
					baseKgBoottent = 20;
					break;
				case 'open-zeilboot':
					baseKgBoottent = 20;
					break;
				case 'platbodem':
					baseKgBoottent = 20;
					break;
				case 'multihull':
					baseKgBoottent = 20;
					break;
				default:
					baseKgBoottent = baseKgBoottent;
			}
		}
		
	
		function getKgPrice(kg) {
			switch (true) {
				case (kg > 0 && kg <1.6):
					return 78; 
				case (kg < 3.1):
					return 178;
				case (kg < 4.1):
					return 232;
				case (kg < 5.1):
					return 260;
				case (kg < 6.1):
					return 288;
				case (kg < 7.1):
					return 309;
				case (kg < 8.1):
					return 343;
				case (kg < 9.1):
					return 365;
				case (kg < 10.1):
					return 387;
				case (kg < 12.1):
					return 409;
				case (kg < 14.1):
					return 419;
				case (kg < 16.1):
					return 425;
				case (kg < 17.1):
					return 463;
				case (kg < 18.1):
					return 470;
				case (kg < 19.1):
					return 475;
				case (kg < 20.1):
					return 480;
				case (kg < 22.1):
					return 510;
				case (kg < 26):
					return 540;
				// case (kg < 30):
				// 	return 550;
				default:
					return 0;
			}
		}
		// $('.js-step-3-niet').hide();
		// $('.js-step-1-welt').hide();
		
	
		bootFormStep0Input.change(function () {
			// Reset price values.
			bootFormPrice.val('').change();
			drStepPrijsindicatieSpan.html('');
			
			// bootFormStep1Wel = $('.form-direct-regelen.boottent .js-step-1-wel');
			 // bootFormStep1Niet = $('.form-direct-regelen.boottent .js-step-1-niet');
	
			selectedGewicht = $(this).val();
			// Display fields based on selection.
			if (selectedGewicht == "niet") {
				bootFormStep1Niet.removeClass('hide');
				bootFormStep1Wel.addClass('hide');
			} 
			else if (selectedGewicht == "wel") {
				bootFormStep1Wel.show();
				$(".instruction ").text('Bij 26m2 of meer komt u in aanmerking voor een speciale prijsvoering.');
				$(".instruction ").show();
	
				bootFormStep1Wel.removeClass('hide');
				bootFormStep1Niet.addClass('hide');
			}
	
			// Always hide prijsindicatie, instructies, extra en footer.
			drStepPrijsindicatie.addClass('hide');
			drStepExtra.addClass('hide');
			drStepFooter.addClass('hide');
		});
	
	
		typeBoot.change(function () {
			selectedBootType = $(this).val();
	
			if ($(this).children('option:first-child').is(':selected')) {
				bootFormStep2Niet.addClass('hide');
			} else {
				bootFormStep2Niet.removeClass('hide');
			}
	
			const label = $(this).children('option:selected').text();
			const value = $(this).val();
			let imgSrc = '';
			let imgSrcS = '';
			let imgSrcM = '';
			let imgSrcL = '';
			if ($(this).children('option:first-child').is(':selected')) {
				imgSrc = `${WP_URL}/uploads/ic-leeg.jpg`;
			
			} else {
				imgSrc = `${WP_URL}/uploads/ic-${value}.jpg`;	
				console.log(imgSrc);
				// imgSrc.on('load', function(e){
				// 	alert('Success!');
				// }).on('error', function(e) {
				// 	alert('ERROR!');
				// });
			}
			
			imgSrcS = `${WP_URL}/uploads/ic-${value}-S.jpg`;	
			$('#boot-image1').empty().append('<img src="' + imgSrcS + '">');
	
			imgSrcM = `${WP_URL}/uploads/ic-${value}-M.jpg`;	
			$('#boot-image2').empty().append('<img src="' + imgSrcM + '">');
	
			imgSrcL = `${WP_URL}/uploads/ic-${value}-L.jpg`;	
			$('#boot-image3').empty().append('<img src="' + imgSrcL + '">');
	
			$('.type-boot p.choice').html(label);
			$('.type-boot img.image-choice').attr('src', imgSrc);
		});
	
		bootFormStep2WelInput.on('input', function () {
			inputNumber = $(this).val();
			// Get the correct prices when inputNumber is filled in.
			if (inputNumber != "") {
				$(".instruction ").text('Bij 30m2 of meer komt u in aanmerking voor een speciale prijsvoering.');
				$(".instruction ").show();
				let totalPrice = getKgPrice(inputNumber);
				drStepPrijsindicatieSpan.html(`Uw prijsindicatie is: <span class="priceSpan">€ ${totalPrice},-</span>`);
				bootFormPrice.val(`€${totalPrice}`).change();
				drStepPrijsindicatie.removeClass('hide');
				drStepExtra.removeClass('hide');
				drStepFooter.removeClass('hide');
			} else {
				drStepPrijsindicatieSpan.html('');
				drStepPrijsindicatie.addClass('hide');
				drStepExtra.addClass('hide');
				drStepFooter.addClass('hide');
			}
			if (inputNumber >= 26) {
				//let totalPrice = getKgPrice(parseFloat(inputNumber));
				drStepPrijsindicatieSpan.html(`Neem contact met ons op.`);
				$(".algemeen").show();
				$(".instruction ").text('Bij 30m2 of meer komt u in aanmerking voor een speciale prijsvoering.');
				$(".instruction ").show();
				$(".meldmijaanniet ").hide();
				$(".informatieID").show();
				$(".informatieID").addClass("active");
				$(".inzamelpunt").hide();
				$(".inzamelID").hide();
				
				drStepPrijsindicatie.removeClass('hide');
				drStepExtraInzamelpunten.removeClass('hide');
				drStepExtra.removeClass('hide');
				drStepFooter.removeClass('hide');
			}
			else {
				$(".inzamelID").show();
				$(".informatieID").removeClass("active");
				$(".algemeen").hide();
				drStepExtraInzamelpunten.removeClass('hide');
	
			}
		});
		typeBoottent.change(function () {
			drStepPrijsindicatie.addClass('hide');
			drStepExtra.addClass('hide');
			drStepFooter.addClass('hide');
			bootFormStep3NietRadio.prop('checked', false);
	
			if ($(this).children('option:first-child').is(':selected')) {
				bootFormStep3Niet.addClass('hide');
		
			} else {			
				bootFormStep3Niet.removeClass('hide');
			}
	
			let label = $(this).children('option:selected').text();
			value = $(this).val();		
			let imgSrc = '';
			if ($(this).children('option:first-child').is(':selected')) {
				imgSrc = `${WP_URL}/uploads/ic-leeg.jpg`;
			} else {
				imgSrc = `${WP_URL}/uploads/ic-${value}.jpg`;
			}
			$('.type-boottent p.choice').html(label);
			$('.type-boottent img.image-choice').attr('src', imgSrc);
		});
		
	
		bootFormStep3NietRadio.change(function () {
			
			drStepPrijsindicatie.removeClass('hide');
			drStepFooter.removeClass('hide');
			drStepExtra.removeClass('hide');
			const selectedBootTypeIndex = typeBoot.prop('selectedIndex') - 1;
			Boottype = typeBoottent.eq(selectedBootTypeIndex).val();
			$(".inzamelID").show();
			$(".inzamelID").removeClass("active");
			$(".informatieID").show();;
			$(".informatieID").removeClass("active");
	
			getKgBoottent(selectedBootType);
	
			let prices = {
				'kajuitzeiljacht': {
					"sprayhood": {
						"small": 178,
						"medium": 232,
						"large": 260
					},
					"cabrioletkap": {
						"small": 260,
						"medium": 288,
						"large": 309
					},
					"buiskap": {
						"small": 288,
						"medium": 309,
						"large": 343
					},
					"bimini": {
						"small": 178,
						"medium": 232,
						"large": 260
					},
					"huik": {
						"small": 78,
						"medium": 178,
						"large": 232
					},
					"flybridgekap": {
					
					},
					"kuiptent": {
						"small": 288,
						"medium": 309,
						"large": 343
					},
					"afdekzeil": {
						"small": 260,
						"medium": 288,
						"large": 309
					},
					"winterkleed": {
						"small": 309,
						"medium": 343,
						"large": 365
					},
					"railingkleed": {
						"small": 78,
						"medium": 78,
						"large": 178
					},
					"maindrop": {
						"small": 178,
						"medium": 178,
						"large": 232
					}
				},
				"kajuitmotorjacht": {
					"sprayhood": {
						"small": 178,
						"medium": 232,
						"large": 260
					},
					"cabrioletkap": {
						"small": 260,
						"medium": 288,
						"large": 309
					},
					"buiskap": {
						"small": 288,
						"medium": 309,
						"large": 343
					},
					"bimini": {
						"small": 178,
						"medium": 232,
						"large": 260
					},
				
					"flybridgekap": {
						"small": 178,
						"medium": 232,
						"large": 260
					},
				
					"winterkleed": {
						"small": 309,
						"medium": 343,
						"large": 365
					},
					"railingkleed": {
						"small": 78,
						"medium": 78,
						"large": 178
					}
				},
				"open-motorboot": {
					"sprayhood": {
						"small": 178,
						"medium": 232,
						"large": 260
					},
					"cabrioletkap": {
						"small": 288,
						"medium": 309,
						"large": 343
					},
					"buiskap": {
						"small": 309,
						"medium": 343,
						"large": 365
					},
					"bimini": {
						"small": 178,
						"medium": 232,
						"large": 260
					},
					"winterkleed": {
						"small": 309,
						"medium": 343,
						"large": 365
					}
				},
				"open-zeilboot": {
					"huik": {
						"small": 78,
						"medium": 178,
						"large": 232
					},
					"kuiptent": {
						"small": 260,
						"medium": 288,
						"large": 309
					},
					"afdekzeil": {
						"small": 260,
						"medium": 288,
						"large": 309
					
					},
					"winterkleed": {
						"small": 309,
						"medium": 343,
						"large": 365
					},
					"zwaardhoes": {
						"small": 78,
						"medium": 78,
						"large": 78
					},
					"maindrop": {
						"small": 178,
						"medium": 178,
						"large": 232
					}
				},
				"platbodem": {
					"huik": {
						"small": 78,
						"medium": 178,
						"large": 232
					},
					"kuiptent": {
						"small": 260,
						"medium": 288,
						"large": 309
					},
					"afdekzeil": {
						"small": 260,
						"medium": 288,
						"large": 309
					
					},
					"winterkleed": {
						"small": 309,
						"medium": 343,
						"large": 365
					},
					"zwaardhoes": {
						"small": 78,
						"medium": 78,
						"large": 78
					},
					"maindrop": {
						"small": 178,
						"medium": 178,
						"large": 232
					}
				},
				"multihull": {
					"bimini": {
						"small": 232,
						"medium": 260,
						"large": 288,
					},
					"huik": {
						"small": 78,
						"medium": 178,
						"large": 232
					},
					"winterkleed": {
						"small": 309,
						"medium": 343,
						"large": 365
					},
	
					"maindrop": {
						"small": 178,
						"medium": 178,
						"large": 232
					}
				},
			}
	
				
			selectedBootlengte = $(this).val();
			drStepPrijsindicatieSpan.html('Uw prijsindicatie is: <span class="priceSpan"> €0,-</span>');
			let totalPrice  ;
			const selectedPrice = prices[selectedBootType][Boottype][selectedBootlengte];
			if (typeof selectedPrice != 'undefined') {
				drStepPrijsindicatieSpan.html(`Uw prijsindicatie is: <span class="priceSpan"> €${selectedPrice},- </span>`);
				bootFormPrice.val(`€${selectedPrice }`).change();
			}
	
		});
	
	
		/**
		 * ZEILEN
		 */
		const zeilFormStep1 = $('.form-direct-regelen.zeilen .js-step-1');
		const zeilFormStep1Radio = zeilFormStep1.find('input[type="radio"]');
		const zeilFormStep2 = $('.form-direct-regelen.zeilen .js-step-2');
		const zeilFormStep2RadioField = $('.form-direct-regelen.zeilen .js-step-2.radio');
		const zeilFormStep2RadioInput = zeilFormStep2RadioField.find('input[type="radio"]');
		const zeilFormStep2NumberField = $('.form-direct-regelen.zeilen .js-step-2.number');
		const zeilFormStep2NumberInput = zeilFormStep2NumberField.find('input[type="text"]');
		const zeilFormStep3 = $('.form-direct-regelen.zeilen .js-step-3');
		const zeilFormStep3RadioField = zeilFormStep3.find('input[type="radio"]');
		const zeilFormStep4 = $('.form-direct-regelen.zeilen .js-step-4');
		const zeilFormStep4ChoicesField = zeilFormStep4.find('input[type="checkbox"]');
	
		const pythInput = $('.form-direct-regelen.zeilen input[type="number"]');
		let pythLength = $('.form-direct-regelen.zeilen input[name="lengte"]');
		let pythWidth = $('.form-direct-regelen.zeilen input[name="breedte"]');
		let pythSquareMeter = $('.form-direct-regelen.zeilen .pyth-result span');
		let sqMtr = 0;
		let selectedGrootte = '';
	
		zeilFormStep2.addClass('hide');
		zeilFormStep3.addClass('hide');
		zeilFormStep4.addClass('hide');
		drStepPrijsindicatie.removeClass('hide');
		drStepExtra.removeClass('hide');
		drStepFooter.removeClass('hide');
	
	
		function getMPrice(m) {
			var fifthplus = "<b>50m+ neem contact met ons op</b>";
			switch (true) {
				case (m < 5):
					return 72,50;
				case (m < 10):
					return 147,50;
				case (m < 15):
					return 200;
				case (m < 20):
					return 225;
				case (m < 25):
					return 250;
				case (m < 30):
					return 275;
				case (m < 30):
					return 300;
				case (m < 40):
					return 325;
				case (m < 45):
					return 350;
				case (m < 50):
					return 375;	
					
				default:
					return 0;
			}
		}
	
		zeilFormStep1Radio.change(function () {
			// Reset price values.
			//zeilFormPrice.val('').change();
			drStepPrijsindicatieSpan.html('');
			$(".instruction ").show();
			$(".instruction ").text('Bij 50m2 of meer komt u in aanmerking voor een speciale prijsvoering.');
			
			// get selected 
			selectedAfmetingen = $(this).val();
			// Display fields based on selection.
			if (selectedAfmetingen == "wel") {
				
				$('.gfield_select').prop('selectedIndex',0);
				inputNumber = '';
				$(".pakketID").removeClass('active');
				$(".informatieID ").removeClass('active');
				$(".inzamelID ").removeClass('active');	
				zeilFormStep2NumberField.removeClass('hide');
				$(".ginput_container_number input").val('');
				$(".instruction ").show();
				$(".instruction ").text('Bij 50m2 of meer komt u in aanmerking voor een speciale prijsvoering.');
				zeilFormStep2RadioField.addClass('hide');
				zeilFormStep3.addClass('hide');
				zeilFormStep4.addClass('hide');
				$("meldmijaanniet").show();
				
				// Always hide prijsindicatie, instructies, extra en footer.
				drStepPrijsindicatie.addClass('hide');
				drStepInstructies.addClass('hide');
				drStepExtra.addClass('hide');
				drStepFooter.addClass('hide');
				$(".inzamelID").show();
				$(".informatieID").removeClass('active');	
				$(".inzamelID ").removeClass('active');	 
				
			} else if (selectedAfmetingen == "niet") {
				
				
				$('.gfield_select').prop('selectedIndex',0);
				inputNumber = null;
				$(".informatieID").show();
				$(".informatieID ").addClass('active');
				$(".pakketID").hide();
				$(".inzamelpunt").hide();
				$(".company_info").hide();
				$(".opening-hours").hide();
				$(".meldmijaanniet").hide()
				$(".algemeen ").show();
				
				// $(".inzamelID").addClass("active");
				
				$(".inzamelID").hide();
				// $(".inzamelID ").removeClass('active');	 
				drStepPrijsindicatie.removeClass('hide');
				$(".ginput_container_number input").val('');
				$(".instruction ").show();
				$(".instruction ").text('Bij + 50m2 of meer komt u in aanmerking voor een speciale prijsvoering.');
				$(".js-step-prijsindicatie ").show();
				zeilFormStep3.addClass('hide');
				zeilFormStep4.addClass('hide');
				drStepPrijsindicatieSpan.html(`Neem contact met ons op.`);
				
				drStepPrijsindicatie.removeClass('hide');
				drStepExtraInzamelpunten.removeClass('hide');
				drStepExtra.removeClass('hide');
				drStepFooter.removeClass('hide');
				// Reset inputNumber so that it won't appear in entries when submitting the form.
				
		
				zeilFormStep2NumberField.addClass('hide');
				zeilFormStep2RadioField.addClass('hide');		
	
			}
	
			
		});
		$(document).on('click', 'input[type="checkbox"]', function() {      
			$('input[type="checkbox"]').not(this).prop('checked', false);
			// drStepPrijsindicatieSpan.html(`Uw prijsindicatie is: € ${totalPrice},-`);
		});
	
	
		zeilFormStep2NumberInput.on('input', function () {
			inputNumber = $(this).val();
			console.log(inputNumber)
	
			// Get the correct prices when inputNumber is filled in.
			if (inputNumber != "null") {
				$(".instruction ").show();
				$(".instruction ").text('Bij 50m2 of meer komt u in aanmerking voor een speciale prijsvoering.');			
				// let totalPrice = getMPrice(parseFloat( inputNumber));
				//Price per m2 is 7 and total price is 7 * input number.
				let totalPrice = ( 7*inputNumber );
				//if the user changes the number uncheck the coathing
				$('input[type="checkbox"]').each(function() {
					this.checked = false;
					drStepPrijsindicatieSpan.html(`Uw prijsindicatie is: <span class="priceSpann">€ ${totalPrice},-</span>`);
	
				});
	
				
				drStepPrijsindicatieSpan.html(`Uw prijsindicatie is: <span class="priceSpan">€ ${totalPrice},-</span>`);
				drStepPrijsindicatie.removeClass('hide');
				drStepExtra.removeClass('hide');
				zeilFormStep4.removeClass('hide');
				drStepFooter.removeClass('hide');
				$(".js-step-extra").show();
				var cautingPrice = 1;
				//Check if the customer needs coaten st1 or st2 (Price is 5,75)
				$('input[name="input_40.1"]').click(function () {
					getSelectedCheckBoxes('input_40.1');
				});
			
				$('input[name="input_40.2"]').click(function () {
					getSelectedCheckBoxes('input_40.2');
				});
				//get checkedbox values 
				var getSelectedCheckBoxes = function (groupName) {
					var result = $('input[name="' + groupName + '"]:checked');
					if (result.length > 0) {
						cautingPrice = result.length;
						result.each(function () {
							cautingPrice = $(this).val();
							$("input[type=checkbox]").change(function () {
								recalculate();
							});
							function recalculate() {
								var sum = 0;
								//Recalculate variable of boot coating
								$("input[type=checkbox]:checked").each(function () {
									if($(this).is(':checked')){
									sum += $(this).val()*inputNumber;
	
									drStepPrijsindicatieSpan.html(`Uw prijsindicatie is: <span class="priceSpan">€ ${totalPrice + sum},-</span>`);
									}
									else {
										console.log('first else on line 1020')
										drStepPrijsindicatieSpan.html(`Uw prijsindicatie is: <span class="priceSpan">€  ${totalPrice},-</span>`);
		
									}
								});
							}
						});
					}
					else {
						drStepPrijsindicatieSpan.html(`Uw prijsindicatie is: <span class="priceSpan">€${totalPrice},-</span> `);
	
					}
				}
			} else {
				drStepPrijsindicatieSpan.html('');
				drStepPrijsindicatie.addClass('hide');
				drStepExtra.addClass('hide');
				drStepFooter.addClass('hide');
			}
			if (inputNumber > 50) {
				$(".instruction ").show();
				zeilFormStep4.addClass('hide');
				//let totalPrice = getKgPrice(parseFloat(inputNumber));
				drStepPrijsindicatieSpan.html(`Neem contact met ons op.`);
				$(".pakketID").hide();
				$(".informatieID").hide();
				$(".meldmijaan").hide();
				$(".algemeen").show();
				$(".inzamelID").addClass("active");
				$(".instruction ").show();
				$(".instruction ").text('Bij 50m2 of meer komt u in aanmerking voor een speciale prijsvoering.');
				drStepPrijsindicatie.removeClass('hide');
				drStepExtraInzamelpunten.removeClass('hide');
				drStepExtra.removeClass('hide');
				drStepFooter.removeClass('hide');
			}
	
			else {
				$(".pakketID").show();
				$(".informatieID").show();
				$(".inzamelID").removeClass("active");
				$(".algemeen").hide();
				drStepExtraInzamelpunten.removeClass('hide');
	
			}
	
		});
		
	
	
		pythInput.keyup(function () {
			sqMtr = +getSquareMeter(pythLength.val(), pythWidth.val()).toFixed(2);
			pythSquareMeter.html(sqMtr);
		});
	
		// Pythagoras' formula for surface area of zeilen.
		function getSquareMeter(pythLength, pythWidth) {
			return Math.sqrt(pythLength * pythLength + pythWidth * pythWidth);
		};
	
		// Select the second radio field in step 1.
		$('.form-direct-regelen.zeilen .js-click-radio').click(function () {
			console.log(' Select the second radio field in step 1')
			zeilFormStep1.find('label#label_12_18_1').click();
			// Simulate key to trigger hidden cards.
			zeilFormStep2NumberInput.val(sqMtr).trigger($.Event('keyup mouseup on input', {
				
				keyCode: 32
				
			}));
		});
	
		/**
		 * ZONWERING
		 */
		const zonFormStep1 = $('.form-direct-regelen.zonwering .js-step-1');
		const typeZonwering = $('.type-zonwering select');
		const zonFormStep2 = $('.form-direct-regelen.zonwering .js-step-2');
		const zonFormStep2Input = zonFormStep2.find('input[type="radio"]');
		const zonFormStep3RadioField = $('.form-direct-regelen.zonwering .js-step-3.radio');
		const zonFormStep3RadioInput = zonFormStep3RadioField.find('input[type="radio"]');
		const zonFormStep3NumberField = $('.form-direct-regelen.zonwering .js-step-3.number');
		const zonFormStep3NumberInput = zonFormStep3NumberField.find('input[type="text"]');
		let zonFormPrice = $('.form-direct-regelen.zonwering .gform_hidden input');
		let selectedZonwering = '';
		let selectedZonweringSpan = $('.js-step-instructies span');
		let selectedAfmetingen = '';
		let selectedOpmeten = '';
	
	
		// Initially hide step fields.
		zonFormStep2.addClass('hide');
		zonFormStep3RadioField.addClass('hide');
		zonFormStep3NumberField.addClass('hide');
	
		// Initially hide prijsindicatie, instructies, extra en footer.
		drStepPrijsindicatie.addClass('hide');
		drStepInstructies.addClass('hide');
		drStepExtra.addClass('hide');
		drStepFooter.addClass('hide');
	
		// Set zonwering price based on selection
		// let basePriceZonwering ;
	
		function getPriceZonwering(zonwering) {
			switch (zonwering) {
				case 'Markiezen':
					basePriceZonwering = 23.50;
					break;
				case 'Uitvalschermen':
					basePriceZonwering = 18.50;
					break;
				case 'Knikarmschermen':
					basePriceZonwering = 18.50;
					break;
				case 'Screendoeken':
					basePriceZonwering = 16.50;
					break;
				case 'Parasols':
					basePriceZonwering = 12.75;
					break;
				default:
					basePriceZonwering = basePriceZonwering;
			}
		}
	
		typeZonwering.change(function () {
			console.log('ik ben hier')
			selectedZonwering = $(this).val();
			bootFormStep3NietRadio.prop('checked', false);
	
			if (!$(this).children('option:first-child').is(':selected')) {
				zonFormStep2.removeClass('hide');
			} else {
				zonFormStep2.addClass('hide');
			}
	
			// Check if inputNumber is not empty so that the correct price will be used
			// and values will be correct when selecting other types of sun screens.
			if (inputNumber != null) {
	
				getPriceZonwering(selectedZonwering);
				let totalPrice =+ (basePriceZonwering * inputNumber).toFixed(2);
				drStepPrijsindicatieSpan.html(`Uw prijsindicatie is: <span class="priceSpan">€ ${totalPrice},-</span>`);
				zonFormPrice.val(`€${totalPrice}`).change();
	
				drStepPrijsindicatie.removeClass('hide');
				drStepExtra.removeClass('hide');
				drStepFooter.removeClass('hide');
			} else if (selectedAfmetingen === 'niet') {
				$(".ginput_container_number input").val('');
				$(".instruction ").show();
				$(".instruction ").text('Bij 50m2 of meer komt u in aanmerking voor een speciale prijsvoering.');
				getPriceZonwering(selectedZonwering);
	
				drStepPrijsindicatieSpan.html(`Uw prijsindicatie is: <span class="priceSpan">€${basePriceZonwering}</span> per m<sup>2</sup>.`);
				zonFormPrice.val(`€${basePriceZonwering} per m2.`).change();
	
				drStepPrijsindicatie.removeClass('hide');
				drStepExtra.removeClass('hide');
				drStepFooter.removeClass('hide');
			} else {
				$(".instruction ").show();
				$(".instruction ").text('Bij 50m2 of meer komt u in aanmerking voor een speciale prijsvoering.');
				drStepPrijsindicatieSpan.html('');
				drStepPrijsindicatie.addClass('hide');
				drStepExtra.removeClass('hide');
				drStepFooter.removeClass('hide');
			}
	
			let label = $(this).children('option:selected').text();
			value = $(this).val();		
			let imgSrc = '';
			if ($(this).children('option:first-child').is(':selected')) {
				imgSrc = `${WP_URL}/uploads/ic-leeg.jpg`;
			} else {
				imgSrc = `${WP_URL}/uploads/ic-${value}.png`;
			}
			$('.type-zonwering p.choice').html(label);
			$('.type-zonwering img.image-choice').attr('src', imgSrc);
	
			// let label = $(this).children('option:selected').text();
			// 	console.log('ik ben hier 00k label', label)
			// let value = $(this).val();
			// console.log('ik ben hier 00k value', value)
			// let imgSrc = `${WP_URL}/uploads/ic-leeg.jpg`;
			// //  let imgSrc = '';
			//  let imgSrcS = '';
			//  let imgSrcM = '';
			//  let imgSrcL = '';
			//  if ($(this).children('option:first-child').is(':selected')) {
			// 	imgSrc = `${WP_URL}/uploads/ic-leeg.jpg`;
			//  } else {
			// 	 imgSrc = `${WP_URL}/uploads/ic-${value}.png`;
			// 	 imgSrc.on('load', function(e){
			// 		alert('Success!');
			// 	}).on('error', function(e) {
			// 		alert('ERROR!');
			// 	});
				
			//  }
			//  imgSrcS = `${WP_URL}/uploads/ic-${value}-S.png`;	
			// $('#boot-image1').empty().append('<img src="' + imgSrcS + '">');
	
			// imgSrcM = `${WP_URL}/uploads/ic-${value}-M.png`;	
			// $('#boot-image2').empty().append('<img src="' + imgSrcM + '">');
			
			
			// imgSrcL = `${WP_URL}/uploads/ic-${value}-L.png`;	
			// $('#boot-image3').empty().append('<img src="' + imgSrcL + '">');
	
			// $('.type-zonwering p.choice').html(label);
			// $('.type-zonwering img.image-choice').attr('src', imgSrc);
		});
	
		zonFormStep2Input.change(function () {
			// Reset price values.
			zonFormPrice.val('').change();
			drStepPrijsindicatieSpan.html('Uw prijsindicatie is: <span class="priceSpan"> €0.00 </span>');
	
			selectedAfmetingen = $(this).val();
	
			// Display fields based on selection.
			if (selectedAfmetingen == "wel") {
				$(".ginput_container_number input").val('');
				$(".instruction ").show();
				$(".instruction ").text('Bij 50m2 of meer komt u in aanmerking voor een speciale prijsvoering.');
				$(".algemeen").hide();
				zonFormStep3NumberField.removeClass('hide');
				zonFormStep3RadioField.addClass('hide');
			}
			//If selected afmeting is 'Ik weet mijn afmeting niet'
			 else if (selectedAfmetingen == "niet") {
				$(".ginput_container_number input").val('');
				$(".algemeen").show();
				drStepPrijsindicatieSpan.html(`Neem contact met ons op.`);
				// Reset inputNumber so that it won't appear in entries when submitting the form.
				inputNumber = null;
				zonFormStep3NumberField.addClass('hide');
				drStepExtra.removeClass('hide');
				drStepFooter.removeClass('hide');
				zonFormStep3RadioField.addClass('hide');
				drStepPrijsindicatie.removeClass('hide');
			}
	
			// Always hide prijsindicatie, instructies, extra en footer.
			drStepPrijsindicatie.removeClass('hide');
			drStepInstructies.addClass('hide');
			drStepExtra.removeClass('hide');
			drStepFooter.removeClass('hide');
		});
	
		zonFormStep3RadioInput.change(function() {
			// change the value of the number field, and trigger calculation.
			zonFormStep3NumberInput.val(this.value).change();
			// drStepPrijsindicatieSpan.html('');
			// drStepPrijsindicatie.addClass('hide');
			drStepExtra.removeClass('hide');
			drStepFooter.removeClass('hide');
		});
	
		function triggerCalc(x){
			$(x).trigger('input');
			inputNumber = $(x).val();
			console.log(inputNumber);
			// Get the correct prices when inputNumber is filled in.
			if ((inputNumber != "") && (inputNumber < 51) ) {
				$(".algemeen").show();
				$(".instruction ").show();
				$(".instruction ").text('Bij 50m2 of meer komt u in aanmerking voor een speciale prijsvoering.');
				console.log(inputNumber, 'is kleiner or groter');
				getPriceZonwering(selectedZonwering);
				let totalPrice = (basePriceZonwering * inputNumber).toFixed(2);
				console.log(totalPrice, 'is kleiner or groter');
				if(totalPrice === 0){
	
					drStepPrijsindicatieSpan.html(`Uw prijsindicaties is <span class="priceSpan">€ ${totalPrice}, </span>`);
					console.log('Ik heb een decimal number')
				}else if(totalPrice !== 0){
					drStepPrijsindicatieSpan.html(`Uw prijsindicaties is <span class="priceSpan">€ ${totalPrice},-</span>`);
					console.log('Ik heb geen decimal number')
	
				}
				// drStepPrijsindicatieSpan.html(`Uw prijsindicatie  is €${totalPrice},-`);
				zonFormPrice.val(`€${totalPrice}`).change();
	
				drStepPrijsindicatie.removeClass('hide');
				drStepExtra.removeClass('hide');
				drStepExtraInfo.removeClass('hide');
				drStepExtraInzamelpunten.removeClass('hide');
				drStepFooter.removeClass('hide');
			}
	
			 else {
				$(".algemeen").show();
				drStepPrijsindicatieSpan.html(`Neem contact met ons op.`);
			}
			
		}
	
	
	
		
		$( ".boot-selected" ).click(function() {
			$(".algemeen").show();
		  });
	
		  $( ".zon-selected" ).click(function() {
			zonFormStep3NumberInput.val(this.value).change();
			$(".algemeen").show();
		  });
	
		zonFormStep3NumberInput.keypress(function(){
	
			triggerCalc(this);
			
			
		});
	
		zonFormStep3NumberInput.on('change', function(){
			triggerCalc(this);	
		});
	});
	
	
	
	($ => {
		/*
		 *  new_map
		 *
		 *  This function will render a Google Map onto the selected jQuery element
		 *
		 *  @type	function
		 *  @date	8/11/2013
		 *  @since	4.3.0
		 *
		 *  @param	$el (jQuery element)
		 *  @return	n/a
		 */
	
		function new_map($el) {
			// var
			const $markers = $el.find('.marker');
	
			// vars
			const args = {
				zoom: 16,
				center: new google.maps.LatLng(0, 0),
				mapTypeId: google.maps.MapTypeId.ROADMAP,
			};
	
			// create map
			const map = new google.maps.Map($el[0], args);
	
			// add a markers reference
			map.markers = [];
	
			// add markers
			$markers.each(function () {
				add_marker($(this), map);
			});
	
			// center map
			center_map(map);
	
			// return
			return map;
		}
	
		/*
		 *  add_marker
		 *
		 *  This function will add a marker to the selected Google Map
		 *
		 *  @type	function
		 *  @date	8/11/2013
		 *  @since	4.3.0
		 *
		 *  @param	$marker (jQuery element)
		 *  @param	map (Google Map object)
		 *  @return	n/a
		 */
	
		function add_marker($marker, map) {
			// var
			const latlng = new google.maps.LatLng($marker.attr('data-lat'), $marker.attr('data-lng'));
	
			// create marker
			const marker = new google.maps.Marker({
				position: latlng,
				map,
			});
	
			// add to array
			map.markers.push(marker);
	
			// if marker contains HTML, add it to an infoWindow
			if ($marker.html()) {
				// create info window
				const infowindow = new google.maps.InfoWindow({
					content: $marker.html(),
				});
	
				// show info window when marker is clicked
				google.maps.event.addListener(marker, 'click', () => {
					infowindow.open(map, marker);
				});
			}
		}
	
	
	
	
		/*
		 *  center_map
		 *
		 *  This function will center the map, showing all markers attached to this map
		 *
		 *  @type	function
		 *  @date	8/11/2013
		 *  @since	4.3.0
		 *
		 *  @param	map (Google Map object)
		 *  @return	n/a
		 */
	
		function center_map(map) {
			// vars
			const bounds = new google.maps.LatLngBounds();
	
			// loop through all markers and create bounds
			$.each(map.markers, (i, marker) => {
				const latlng = new google.maps.LatLng(marker.position.lat(), marker.position.lng());
	
				bounds.extend(latlng);
			});
	
			// only 1 marker?
			if (map.markers.length == 1) {
				// set center of map
				map.setCenter(bounds.getCenter());
				map.setZoom(13);
			} else {
				// fit to bounds
				map.fitBounds(bounds);
			}
		}
	
		function show_selected() {
			//var e = document.getElementById("input_11_5");
			var e = document.getElementById("input_11_5");
			var selectedLocation = e.options[e.selectedIndex].value;
	
			//document.getElementById('display').innerHTML = value;
		}
	
		/*
		 *  document ready
		 *
		 *  This function will render each map when the document is ready (page has loaded)
		 *
		 *  @type	function
		 *  @date	8/11/2013
		 *  @since	5.0.0
		 *
		 *  @param	n/a
		 *  @return	n/a
		 */
		// global var
		let map = null;
	
		$(document).ready(() => {
			$('.acf-map').each(function () {
				// create map
				map = new_map($(this));
			});
		});
	})(jQuery);
	
	
	
	